<template>
  <Page>
    <BSearch
      :search-list="searchList"
      @on-search="searchHandler"
    >
      <span slot="left">
        <a-button @click="handleCreateChannelAccount" type="primary" class="button-color-cyan">新增渠道账户</a-button>
      </span>
    </BSearch>
    <BTable
      style="margin-top: 20px;"
      ref="table"
      size="default"
      :rowKey="(text, index) => index"
      :scroll="{ x: true }"
      :columns="columns"
      :data="loadData"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleBalance(record)">余额</a>
        <a-divider type="vertical" />
        <a @click="handleUpdate(record)">更新</a>
        <a-divider type="vertical" />
        <a @click="handleSubAccount(record)">子账号管理</a>
       </span>
    </BTable>
    <CreateChannelAccount
      width="800px"
      title="新增渠道账户"
      :channel-list="channelList"
      ref="createChannelAccount"
      @success="() => { this.$refs.table.refresh(true) }"
    />
    <Balance
      title="渠道账户余额"
      :acctCurList="acctCurList"
      ref="balance"
    />
    <UpdateAccount
      title="更新渠道账户"
      width="800px"
      :channel-list="channelList"
      :item="modifyItem"
      ref="updateAccount"
      @success="() => { this.$refs.table.refresh() }"
    />
    <SubAccount
      title="子账户管理"
      width="800px"
      ref="subAccount"
      :item="subItem"
    />
  </Page>
</template>

<script>
// import moment from 'moment'

export default {
  name: 'Account',
  components: {
    CreateChannelAccount: () => import('./components/CreateChannelAccount'),
    Balance: () => import('./components/Balance'),
    UpdateAccount: () => import('./components/UpdateAccount'),
    SubAccount: () => import('./components/SubAccount')
  },
  data () {
    return {
      queryParam: {},
      loadData: parameter => {
        const request = {
          ...this.queryParam
        }
        return this.$http.channel.channelAcctQueryPage(Object.assign(parameter, { request })).then(response => {
          const { data } = response
          return data
        })
      },
      searchList: [
        {
          label: '渠道名称',
          key: 'channelNo',
          type: 'select',
          options: [],
          optionKey: 'channelNo',
          optionValue: 'channelName'
        }
      ],
      changeLoading: false,
      columns: Object.freeze([
        {
          title: '序号',
          fixed: 'left',
          customRender: (text, record, index) => index + 1
        },
        {
          title: '渠道号',
          dataIndex: 'channelNo' // no
        },
        {
          title: '渠道名称',
          dataIndex: 'channelName' // no
        },
        {
          title: '渠道账户号',
          dataIndex: 'channelAcctNo'
          // sorter: true,
          // needTotal: true,
          // customRender: (text) => text + ' 次'
        },
        {
          title: '渠道账户名称',
          dataIndex: 'channelAcctName'
          // needTotal: true
        },
        {
          title: '渠道账户币种类型', // 请求接口？
          dataIndex: 'channelAcctCurTypeDesc'
        },
        {
          title: '渠道账号科目编号', // 请求接口？
          dataIndex: 'channelAcctSubjectNo'
        },
        {
          title: '创建人',
          dataIndex: 'createUserName'
          // customRender: () => '没有'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '更新人',
          dataIndex: 'updateUserName'
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '200px',
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ]),
      modifyItem: {},
      acctCurList: [],
      channelList: [],
      subItem: {}
    }
  },
  async created () {
    await this.getQueryParams()
  },
  methods: {
    async getQueryParams () {
      const { data } = await this.$http.channel.channelQueryList({ request: {} })
      const channelSelect = this.searchList[0]
      this.channelList = data
      this.$set(this.searchList, 0, Object.assign({}, channelSelect, { options: data }))
    },
    handleCreateChannelAccount () {
      this.$refs.createChannelAccount.visible = true
      this.$refs.createChannelAccount.getCurrency()
    },
    handleBalance (item) {
      const { channelAcctCurAmtMap } = item
      this.acctCurList = this.$u.getArrayByObjectAttrs(channelAcctCurAmtMap)
      this.$refs.balance.visible = true
    },
    handleSubAccount (item) {
      this.subItem = item
      this.$refs.subAccount.visible = true
    },
    handleUpdate (item) {
      this.modifyItem = item
      this.$refs.updateAccount.visible = true
      this.$refs.updateAccount.getCurrency()
    },
    searchHandler (values) {
      this.queryParam = values
      this.$refs.table.refresh(true)
    }
  }
}
</script>

<style scoped lang="less">
</style>
